import "./App.scss";
import { BrowserRouter, Route } from "react-router-dom";

import Routes from "./config/Routes";

function App() {
  return (
    <BrowserRouter>
      <Route
        render={() => (
          <div>
            <Routes />
          </div>
          
        )}
      />
    </BrowserRouter>
  );
}

export default App;
